import { gql } from '@apollo/client';

import { assessmentPlannerFragment } from 'approot/assessment/sections/details/details.graphql';
import { lessonPlannerFragment } from 'approot/lesson/sections/details/details.graphql';
import {
  completionFragment,
  plannerTermsFragment,
} from 'approot/planner/manage/planner.graphql';
import { unitPlannerFragment } from 'approot/unit/unit.graphql';

export const UPDATE_LESSON_IN_PLANNER = gql`
  mutation UpdateLessonInPlanner($input: UpdateLessonInPlannerInput!) {
    updateLessonInPlanner(input: $input) {
      lesson {
        id
        completion {
          ...Completion
        }
        unit {
          ...UnitPlannerFragment
        }
        integratedUnit {
          ...UnitPlannerFragment
        }
        ...LessonPlannerFragment
      }
      unitAddedToPlanner
      unitId
      term
      plannerItemGroupId
      planner {
        id
        ...PlannerTermsFragment
      }
    }
  }
  ${unitPlannerFragment}
  ${lessonPlannerFragment}
  ${completionFragment}
  ${plannerTermsFragment}
`;

export const UPDATE_ASSESSMENT_IN_PLANNER = gql`
  mutation UpdateAssessmentInPlanner($input: UpdateAssessmentInPlannerInput!) {
    updateAssessmentInPlanner(input: $input) {
      assessment {
        id
        completion {
          ...Completion
        }
        unit {
          ...UnitPlannerFragment
        }
        integratedUnit {
          ...UnitPlannerFragment
        }
        ...AssessmentPlannerFragment
      }
      unitAddedToPlanner
      unitId
      term
      plannerItemGroupId
      planner {
        id
        ...PlannerTermsFragment
      }
    }
  }
  ${unitPlannerFragment}
  ${assessmentPlannerFragment}
  ${completionFragment}
  ${plannerTermsFragment}
`;
